// extracted by mini-css-extract-plugin
module.exports = {"text":"text-module--text--2cRVB"};